import styled from "styled-components";

export const MobileMenu = styled.div`
  @media(max-width: 1024px) {
    display: block;
  }
  display: none;
`